import { ModuleType, ApplicationType } from 'rs-transfer';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AssetService } from './../../../core/services/asset/asset.service';
import { Component, ViewChild, OnInit, Input } from '@angular/core';
import { AuthService } from '../../../core/services/auth/auth.service';
import {  transferEnv } from '../../../app.constants';
import { Subject } from 'rxjs';
import { Asset } from '../../../core/models/types';

@Component({
    selector: 'processingImportFile',
    template: require('./processing-import-file.html'),
    // styles: [require('./file-importer.css')],
})
export class ProcessingImportFileComponent implements OnInit {
    @Input() isChildComponent = false;
    @Input() asset: Asset;
    AuthService;
    currentCompany;
    currentUser;
    comment;
    NgbActiveModal;
    files = [];
    AssetService;
    uploadRsFiles: Subject<any> = new Subject();
    urlInfos = {
        ApplicationId: ApplicationType.Lightbox,
        AccessToken : localStorage.getItem('access_token'),
        Url: transferEnv,
        CompanyId: undefined,
        ReturnFile: true,
        GenerateThumb: true,
        SetVersion: true,
        Module : ModuleType.Undefined,
        texts: {
          afterUploadMsg_success: 'Successfully Uploaded !',
          afterUploadMsg_error: 'Upload Failed !',
          title: 'Upload your images',
        }
      };

    static parameters = [AuthService, AssetService, NgbActiveModal];
    constructor(private authService: AuthService,  assetService: AssetService, activeModal: NgbActiveModal) {
        this.AuthService = authService;
        this.NgbActiveModal = activeModal;
        this.currentUser = this.AuthService.currentUser;
        this.AssetService = assetService;
        this.setCurrentCompany();
    }
    setCurrentCompany(){
        this.currentCompany = this.AuthService.currentSelectedCompany;
        this.urlInfos.CompanyId = this.currentCompany.EntityId;
        this.AuthService.currentSelectedCompanyChanged.subscribe(company => {
            this.currentCompany = company;
            this.urlInfos.CompanyId = this.currentCompany.EntityId;
        });
    }

    ngOnInit(){

    }
    docUpload(e){

    }
    close(){
        this.NgbActiveModal.dismiss('Cross click');
    }

    uploadValidation(){
        this.uploadRsFiles.next(true);
        var component = this;
        this.uploadRsFiles.subscribe((data) => {


                    if( data instanceof Array ){
                        data.forEach(element => {
                               //Create
                               var assets = [];
                               data.forEach(element => {
                                var asset = new Asset();
                                asset.RsFileId = element.id;
                                asset.fullname = element.name;
                                asset.comment = this.comment;
                                asset.CompanyId = this.currentCompany._id;
                                assets.push(asset);
                               });
                               this.AssetService.createValidation(assets).subscribe((result) => {
                                this.close();
                            })
                    });
                    }

        });
    }

    onSelect(e){

    }
}
